import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrescriptionStatus } from 'src/app/enums/prescription-status';
import { MedicalCareRecord } from 'src/app/models/medical-care-record';
import { MedicalOrder } from 'src/app/models/medical-order';
import { Prescription } from 'src/app/models/prescription';
import { CallService } from 'src/app/services/call.service';

const { SENT, SENT_UNVALIDATED } = PrescriptionStatus;

export interface CallFilesDialogData {
  callId: string;
}

@Component({
  selector: 'app-call-files-dialog',
  templateUrl: './call-files-dialog.component.html',
  styleUrls: ['./call-files-dialog.component.css'],
  standalone: false
})
export class CallFilesDialogComponent implements OnInit {
  prescriptions?: Prescription[];
  medicalOrders?: MedicalOrder[];
  medicalCareRecord?: MedicalCareRecord;
  instructions: string[] = [];
  urls: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CallFilesDialogData,
    private callService: CallService
  ) {}

  async ngOnInit(): Promise<void> {
    const [call, urls] = await Promise.all([this.callService.getCall(this.data.callId), this.callService.getCallUrlPdfs(this.data.callId)]);

    this.prescriptions = call.prescriptions;
    this.medicalOrders = call.medicalOrders;
    this.medicalCareRecord = call.medicalCareRecord;
    this.urls = urls;

    this.prescriptions?.forEach((prescription) => {
      if (
        (prescription.status === SENT || prescription.status === SENT_UNVALIDATED) &&
        !this.instructions.includes(prescription.instructionsS3Key)
      ) {
        this.instructions.push(prescription.instructionsS3Key);
      }
    });
  }
}
